<template>
    <node-view-wrapper class="collapsed-mail-wrapper">
        <a-tooltip title="Kısaltılmış içeriği görüntüle" placement="top" v-if="isCollapsed">
            <div class="collapsed-mail-button" @click="expand">
                <i class="material-icons">more_horiz</i>
            </div>
        </a-tooltip>
        <div class="mail-content" v-html="node.attrs.content" v-else></div>
    </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper } from '@tiptap/vue-2'

export default {
    name: 'CollapsedMailComponent',
    components: {
        NodeViewWrapper
    },
    props: {
        editor: {
            type: Object,
            required: true,
        },
        node: {
            type: Object,
            required: true,
        },
        updateAttributes: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            isCollapsed: true
        }
    },
    mounted() {
        this.isCollapsed = true;
    },
    methods: {
        expand() {
            this.isCollapsed = false;
        }
    }
}
</script>

<style>
.collapsed-mail-button {
    background-color: #e8eaed;
    border-radius: 10px;
    width: 30px;
    height: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.collapsed-button i {
    font-size: 20px;
    color: #434445;
    line-height: 0px;
}
</style>